import websiteActions from '@nocode-works/template/store/modules/website'
import templateActions from 'store/modules/template'
import stripeActions from 'store/modules/stripe'
import appsumoActions from 'store/modules/appsumo'
import userSelectors from 'store/selectors/user'

const authHandlers = {
  guest: (state) => userSelectors.loggedIn(state) ?
    'home' :
    null,
  user: (state) => userSelectors.loggedIn(state) ?
    null :
    'login',
}

const routes = [
  {
    name: 'login',
    path: '/login',
    authorize: authHandlers.guest,
  },
  {
    name: 'appsumo',
    path: '/appsumo',
    children: [
      {
        name: 'activate',
        path: '/activate',
        trigger: async (store) => {
          store.dispatch(appsumoActions.activate())
        },
      },
      {
        name: 'welcome',
        path: '/welcome',
        trigger: async (store) => {
          store.dispatch(stripeActions.loadAll())
        },
      },
    ]
  },
  {
    name: 'home',
    path: '/',
    authorize: authHandlers.user,
    redirect: 'website.list',
  },
  {
    name: 'scope',
    path: '/scope/:type',
  },
  {
    name: 'help',
    path: '/help',
  },
  {
    name: 'notfound',
    path: '/notfound',
  },
  {
    name: 'website',
    path: '/website',
    redirect: 'website.list',
    authorize: authHandlers.user,
    children: [
      {
        name: 'list',
        path: '/list',
        trigger: async (store) => {
          store.dispatch(websiteActions.list())
          store.dispatch(templateActions.listAll())
          store.dispatch(appsumoActions.loadPlans())
        },
      },
      {
        name: 'edit',
        path: '/edit/:id',
        trigger: async (store, params) => {
          store.dispatch(websiteActions.get(params.id))
          store.dispatch(stripeActions.loadProducts())
          store.dispatch(stripeActions.loadCustomer())
          store.dispatch(websiteActions.loadConfig(params.id))
          store.dispatch(websiteActions.loadDnsInfo())
          store.dispatch(websiteActions.loadTemplate(params.id))
          store.dispatch(appsumoActions.loadPlans())
        },
      },
    ]
  },
  {
    name: 'template',
    path: '/template',
    redirect: 'template.list',
    authorize: authHandlers.user,
    children: [
      {
        name: 'list',
        path: '/list',
        trigger: async (store) => {
          await store.dispatch(templateActions.list())
        },
      },
      {
        name: 'view',
        path: '/view/:id',
        trigger: async (store, params) => {
          await store.dispatch(templateActions.get(params.id))
        },
      },
    ]
  },
  {
    name: 'account',
    path: '/account',
    redirect: 'account.settings',
    authorize: authHandlers.user,
    children: [
      {
        name: 'settings',
        path: '/settings',
      },
      {
        name: 'payments',
        path: '/payments',
        trigger: async (store) => {
          store.dispatch(stripeActions.loadAll())
        },
      },
    ]
  },
]

export default routes